import matchMedia from 'manager/matchMedia';



class Tile {
  trim(data) {
    var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    return data.replace(rtrim, '');
  }

  render(element) {
    this.$element = element;
    var selector = this.trim(this.$element.data('tile')).split('|'),
        i = 0, sl = selector.length;

    for (; i < sl; i++) {
      var $children = this.$element.find(selector[i]),
          maxheight = 0,
          heights   = [],
          j         = 0,
          cl        = $children.length;

      if (dn.$store.getters['mq/pc']) {
        for (; j < cl; j++) (function($element) {
          var addHeight = 0;
          $($element).find('.mdAddHeight').each(function(){
            addHeight += $(this).get(0).offsetHeight;
          });
          heights.push($element.height() + addHeight);
        })($children.eq(j));

        $children.css('height', Math.max.apply({}, heights));
      } else {
        $children.css('height', 'auto');
      }
    }
  }
}

export default class DNTile {
  constructor() {
    this.renderer = new Tile();
    this.$targets = null;
  }

  init() {
    this.$targets = $('[data-tile]').filter(function(index) {
      return !$(this).parents('pre').length;
    });

    if (!this.$targets.get(0)) return;

    matchMedia.hasAndOn(`change-pc.dn-tile`, () => {
      this.update();
    });
  }

  update() {
    const my = this;

    my.$targets.each(function() {
      my.renderer.render($(this));
    });
  }
}



// WEBPACK FOOTER //
// ./src/js/manager/old-modules/modules/DNTile.js